import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>© 2025 Aggarwal Tour Company | Contact: +91 8791918881 / +91 7206492722</p>
    </footer>
  );
};

export default Footer;